export default "__VITE_PUBLIC_ASSET__ff7856a6__"